module.exports = __webpack_public_path__ + "static/media/French_Brigitte BG-16.39ad6daa.png";